import React from "react";
import { Card } from "rebass";
import { MdClose } from "react-icons/md";

interface IProps {
  onClick(event: React.MouseEvent): void;
}

export const CloseButton: React.FC<IProps> = ({ onClick }) => (
  <Card
    as="button"
    type="button"
    p="7px"
    borderRadius="50%"
    color="wild-blue"
    bg="#fff"
    boxShadow="0 3px 29px 0 rgba(0, 0, 0, 0.23)"
    css="position: absolute; top: 0; right: 0; transform: translate(6px, -6px); z-index: 1;"
    onClick={onClick}
  >
    <MdClose display="block" size={29.15} />
  </Card>
);
